import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export const THEMES = [
  { id: "bedtime", label: "Bedtime Calm", emoji: "🌙" },
  { id: "adventure", label: "Grand Adventure", emoji: "🐉" },
  { id: "kindness", label: "Learning Kindness", emoji: "💛" },
  { id: "space", label: "Space Explorer", emoji: "🚀" },
  { id: "underwater", label: "Underwater Quest", emoji: "🐳" },
  { id: "forest", label: "Magical Forest", emoji: "🍄" },
];

export default function StepTheme({ story, setStory }) {
  return (
    <div className="space-y-5" data-testid="step-2">
      <h1 className="font-display text-3xl font-bold text-[#2B2D42]">What kind of story?</h1>
      <p className="text-[#4A4E69]">Pick a theme, and add your own twist if you like.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {THEMES.map((t) => (
          <button key={t.id} data-testid={`theme-${t.id}`} type="button"
            onClick={() => setStory({ ...story, theme: t.id })}
            className={`paper-card p-4 text-left transition-all ${story.theme === t.id ? "ring-2 ring-[#E07A5F] -translate-y-1" : "hover:-translate-y-0.5"}`}>
            <div className="text-3xl">{t.emoji}</div>
            <div className="mt-2 font-bold text-[#2B2D42]">{t.label}</div>
          </button>
        ))}
      </div>
      <div>
        <Label>Extra idea (optional)</Label>
        <Textarea data-testid="custom-prompt" value={story.custom_prompt}
          onChange={(e) => setStory({ ...story, custom_prompt: e.target.value })}
          placeholder="e.g. she meets a friendly whale that hums lullabies" rows={3} />
      </div>
    </div>
  );
}
